import React, { useState } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { sendAnalytics } from "../../../action/homeAction";
import { cancelRestaurantReservationV2 } from "../../../action/resReservationV2";
import { cancelMySpaBooking } from "../../../action/spaBooking";
import { cancelEvent } from "../../../action/events7rooms";


const Event_CancelReservation = (props) => {

    const { t } = props

    const [loading, setLoading] = useState(false);
     let label = getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" })
     let widgetSesstionId = localStorage.getItem("eventsBookingSessionToken");

     
    const handleDeleteReservation = async () => {
        setLoading(true);
        let deletedSuccessfully = true;
        console.log("appointmentid for cancle", props.appointmentId)
        const payload = {
        "reservationId": props.appointmentId
             }

        let msg;

        try {
            const res = await cancelEvent(payload);

             
            if (res && res.status == 200 && res.data && res.data.header && res.data.header.status && res.data.header.status.code == "SUCCESS") { // add other checkers

                props.sendAnalytics(
                    props.guestDetail,
                    props.currentWidgets.widgetType,
                    "CANCEL RESERVATION - Success",
                    { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId, "deleteReservationID": props.appointmentId },
                    0,
                    props.guestIsLoggedIn
                );
            }else{
                deletedSuccessfully = false;

                props.sendAnalytics(
                    props.guestDetail,
                    props.currentWidgets.widgetType,
                    "CANCEL RESERVATION - ERROR",
                    {
                        ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId, "deleteReservationID": props.appointmentId, "errorStatus": (res && res.response)?res.response.status:"", "errorMessage": JSON.stringify(
                            res && res.response && res.response.data && res.response.data.header && res.response.data.header.status && res.response.data.header.status.msg,
                        )
                    },
                    0,
                    props.guestIsLoggedIn
                );

            }
            msg = (res && res.data && res.data.header && res.data.header.status && res.data.header.status.msg);
        } catch (err) {
            console.log(err);
            deletedSuccessfully = false;
        }

        setLoading(false);
        props.handleDeleteReservation(deletedSuccessfully , msg);
    };

     


    React.useEffect(() => {
        console.log(props.appointmentId)
    }, [])

    return (
        <>
            <section class="overlay">
                <div class="overlay-window-container">
                    <div class="overlay-window">
                        <div class="overlay-content padding-0">
                            <div class="overlay-header">
                                <div class="overlay-header-title">
                                    <h2 style={{ color: "#000 !important" }}>{t('events.cancel_reser.heading1')}</h2>
                                    <p>{t('events.cancel_reser.subHeading')}</p>
                                </div>
                                <div class="overlay-header-icon">
                                    <i class="fas fa-calendar"></i>
                                </div>
                            </div>
                        </div>
                        {/* <div class="overlay-controls form-row align-left padding-left-1 padding-right-1">
                            <label>{t('events.cancel_reser.reason_heading')}</label>
                            <input type="text" name="Cancellation Reason" value={reason} onChange={(e) => setReason(e.target.value)} placeholder={t('spaBooking.cancel_reser.reason_placeholder')} />
                        </div> */}

                        <div class="overlay-controls">
                            {loading ? <button disabled class="button"><div class="loader-ring"><img src="layout_2/assests/loader.png" /></div> {t('events.cancelling')}</button> : <button onClick={() => handleDeleteReservation()} class="button">{t('events.proceed')}</button>}
                            <button onClick={() => props.close()} class="button secondary">{t('events.close')}</button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}


const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
    }
}

export default connect(mapStateToProps, { sendAnalytics })(withTranslation('translations')(Event_CancelReservation));